import '@fortawesome/fontawesome-free/css/all.min.css'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import './assets/styles/Style.css'
import './index.css'

import * as Sentry from '@sentry/react'
import { browserTracingIntegration, replayIntegration } from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { AuthProvider } from './contexts/auth'
import { HeaderVisibilityProvider } from './contexts/HeaderVisibilityContext'
import { MediaQueryProvider } from './contexts/MediaQueryContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { useFavicon } from './hooks/useFavicon'
import Router from './router'
import store from './store/store'

const { MODE, VITE_SENTRY_KEY } = import.meta.env

Sentry.init({
  dsn: VITE_SENTRY_KEY as string,
  sendDefaultPii: true,
  integrations: [browserTracingIntegration(), replayIntegration()],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: MODE,
  enabled: !location.host.includes('localhost'),
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

// Feature flags
export const disableScreenShare = false

function App() {
  useFavicon()
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  return (
    <MediaQueryProvider>
      <HeaderVisibilityProvider>
        <Provider store={store}>
          <BrowserRouter>
            <AuthProvider>
              <ThemeProvider>
                <QueryClientProvider client={queryClient}>
                  <Router />
                  <ToastContainer
                    toastClassName="tc-mv-blur text-white mx-4 md:mx-0"
                    position="top-right"
                    autoClose={3000}
                  />
                  <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
              </ThemeProvider>
            </AuthProvider>
          </BrowserRouter>
        </Provider>
      </HeaderVisibilityProvider>
    </MediaQueryProvider>
  )
}

export default App
